// extracted by mini-css-extract-plugin
export var carrierTab = "_4b-0";
export var carrierTabActive = "_4b-1 _4b-0";
export var carrierTabInactive = "_4b-2 _4b-0";
export var carrierTabLabel = "_4b-3";
export var carrierTabLabelActive = "_4b-4 _4b-3";
export var carrierTabLabelInactive = "_4b-5 _4b-3";
export var carrierTabPercentage = "_4b-6";
export var carrierTabPercentageActive = "_4b-7 _4b-6";
export var carrierTabPercentageInactive = "_4b-8 _4b-6";
export var carrierTabWinnable = "_4b-9";
export var carrierTabWinnableActive = "_4b-a _4b-9";
export var carrierTabWinnableInactive = "_4b-b _4b-9";
export var comparisonContainer = "_4b-d";
export var missingRateButton = "_4b-n";
export var missingRateButtonActive = "_4b-o _4b-n";
export var missingRateButtonInactive = "_4b-p _4b-n";
export var missingRateButtonLabel = "_4b-q";
export var missingRateButtonLabelActive = "_4b-r _4b-q";
export var missingRateButtonLabelInactive = "_4b-s _4b-q";
export var sidebar = "_4b-c";
export var strategyButton = "_4b-e";
export var strategyButtonActive = "_4b-f _4b-e";
export var strategyButtonDescription = "_4b-k";
export var strategyButtonDescriptionActive = "_4b-l _4b-k";
export var strategyButtonDescriptionInactive = "_4b-m _4b-k";
export var strategyButtonInactive = "_4b-g _4b-e";
export var strategyButtonLabel = "_4b-h";
export var strategyButtonLabelActive = "_4b-i _4b-h";
export var strategyButtonLabelInactive = "_4b-j _4b-h";
export var unitToggleButton = "_4b-t";
export var unitToggleButtonActive = "_4b-u _4b-t";
export var unitToggleButtonInactive = "_4b-v _4b-t";
export var unitToggleButtonLabel = "_4b-w";
export var unitToggleButtonLabelActive = "_4b-x _4b-w";
export var unitToggleButtonLabelInactive = "_4b-y _4b-w";